exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svg-wrap{position:relative;overflow:visible}#atap{fill:#ffeb3b;-webkit-animation:pulse .5s linear infinite alternate;animation:pulse .5s linear infinite alternate}#rumah{fill:#ffca28}@-webkit-keyframes pulse{0%{transform:translateY(-.2px)}25%{transform:translateY(.2px)}60%{transform:translateY(.6px)}to{transform:translateY(.9px)}}@keyframes pulse{0%{transform:translateY(-.2px)}25%{transform:translateY(.2px)}60%{transform:translateY(.6px)}to{transform:translateY(.9px)}}", ""]);

// exports
